<script lang="ts">
export default {
  name: 'TypeIt',
  props: {
    buySellTexts: {
      type: Array as () => string[],
      required: true
    },
    slogans: {
      type: Array as () => string[],
      required: true
    },
    yourText: {
      type: String,
      required: true
    },
    speed1: {
      type: Number,
      default: 100 // Default speed for animation1 in milliseconds
    },
    speed2: {
      type: Number,
      default: 100 // Default speed for animation2 in milliseconds
    },
    delayAfterDelete: {
      type: Number,
      default: 0 // Default delay after deleting text in milliseconds
    },
    delayEnd: {
      type: Number,
      default: 2000 // Default delay between animations in milliseconds
    }
  },
  data() {
    return {
      currentBuySellTextIndex: 0,
      currentSloganIndex: 0,
      firstIteration: true,
      localSlogans: [] as string[]
    };
  },
  mounted() {
    this.localSlogans = this.randomizeArray(
        this.slogans
    );
    this.setInitialText();
    this.startAnimation1();
  },
  methods: {
    randomizeArray(array: string[]) {
      return array.sort(() => Math.random() - 0.5);
    },
    setInitialText() {
      const sloganElement = this.$refs.slogan as HTMLElement;
      sloganElement.innerHTML = this.localSlogans[this.currentSloganIndex];

      const buySellElement = this.$refs.buySellText as HTMLElement;
      buySellElement.innerHTML = this.buySellTexts[this.currentBuySellTextIndex];
    },
    startAnimation1() {
      const sloganElement = this.$refs.slogan as HTMLElement;

      this.deleteText(sloganElement, this.localSlogans[this.currentSloganIndex], this.speed1, () => {
        this.currentSloganIndex = (this.currentSloganIndex + 1) % this.localSlogans.length;
        setTimeout(() => {
          this.typeText(sloganElement, this.localSlogans[this.currentSloganIndex], this.speed1, () => {
            setTimeout(() => {
              this.startAnimation2();
            }, this.delayEnd);
          });
        }, this.delayAfterDelete);
      });
    },
    startAnimation2() {
      const buySellElement = this.$refs.buySellText as HTMLElement;

      this.deleteText(buySellElement, this.buySellTexts[this.currentBuySellTextIndex], this.speed2, () => {
        this.currentBuySellTextIndex = (this.currentBuySellTextIndex + 1) % this.buySellTexts.length;
        setTimeout(() => {
          this.typeText(buySellElement, this.buySellTexts[this.currentBuySellTextIndex], this.speed2, () => {
            setTimeout(() => {
              this.startAnimation1();
            }, this.delayEnd);
          });
        }, this.delayAfterDelete);
      });
    },
    deleteText(element: HTMLElement, text: string, speed: number, callback: () => void) {
      let index = text.length;
      const interval = setInterval(() => {
        if (index > 0) {
          element.innerHTML = text.substring(0, index - 1);
          index--;
        } else {
          clearInterval(interval);
          callback();
        }
      }, speed);
    },
    typeText(element: HTMLElement, text: string, speed: number, callback: () => void) {
      let index = 0;
      const interval = setInterval(() => {
        if (index < text.length) {
          element.innerHTML += text.charAt(index);
          index++;
        } else {
          clearInterval(interval);
          callback();
        }
      }, speed);
    }
  }
}
</script>

<template>
  <div class="typeit-words">
    <span class="typeit-words__buysell" ref="buySellText"></span> {{ yourText }} <span ref="slogan"></span>
  </div>
</template>
